<template>
  <div class="container">
    <header class="jumbotron">
      <h3>{{content}}</h3>
    </header>
  </div>
</template>

<script>
import AppBoardService from '../services/app-board.service';

export default {
  name: 'Manager',
  data() {
    return {
      content: ''
    };
  },
  mounted() {
    AppBoardService.getManagerBoard().then(
      response => {
        this.content = response.data;
      },
      error => {
        this.content =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
      }
    );
  }
};
</script>